import { logError } from '@chronosphereio/core';

export const CHANGE_EVENTS_UI_MODES = ['enabled', 'disabled', 'read-only'] as const;

export type ChangeEventsUiMode = (typeof CHANGE_EVENTS_UI_MODES)[number];

export function getChangeEventsUiMode(mode: string): ChangeEventsUiMode {
  for (const validMode of CHANGE_EVENTS_UI_MODES) {
    if (validMode === mode) {
      return mode;
    }
  }

  logError(new Error(`Received invalid value '${mode}' for enableChangeEventsUi feature flag`));
  return 'disabled';
}

export function canViewChangeEvents(mode: string): boolean {
  const value = getChangeEventsUiMode(mode);
  return value === 'enabled' || value === 'read-only';
}

export function canCreateChangeEvents(mode: string): boolean {
  return getChangeEventsUiMode(mode) === 'enabled';
}
